export const SET_FILTER = 'SET_FILTER';

export const setFilter = filter => ({type: SET_FILTER, value: {filter}});
